<template>
  <div>
    <section class="section is-marginless is-paddingless">
      <ImageH v-if="project" link :image="cover"></ImageH>
    </section>

    <Project v-if="project">
      <div v-if="$store.state.auth.role.level <= 2" slot="topbar">
        <div class="buttons">
          <ToggleButton
            cssInactive="is-inverted is-outlined"
            css="is-success"
            icon="fas fa-check"
            :active="project.active"
            @click="SaveProjectProp('active', !project.active)"
            >Publicerad</ToggleButton
          >

          <ToggleButton
            cssInactive="is-inverted is-outlined"
            css="is-success"
            icon="fas fa-check"
            :active="hasPage"
            @click="AddRemoveProjectPage('/')"
            >Startsida</ToggleButton
          >
        </div>
      </div>
      <EditSingleField
        slot="title"
        v-model="project.title"
        :saveFunc="SaveProject"
      ></EditSingleField>
      <EditSingleField
        slot="subtitle"
        v-model="project.subtitle"
        :saveFunc="SaveProject"
      ></EditSingleField>
      <EditField
        slot="description"
        v-model="project.description"
        :saveFunc="SaveProject"
      ></EditField>

      <div v-if="$store.state.auth.role.level <= 2" slot="bottombar">
        <div
          class="button is-danger is-pulled-right is-rounded"
          @click="showDeleteModal = true"
        >
          Ta bort projektet
        </div>
      </div>
    </Project>

    <div v-if="project" class="section mb mt">
      <div class="container">
        <ImageUploader
          v-if="$store.state.auth.role.level <= 2"
          path="upload/card/image"
          css="is-primary"
          class="box"
          btnName="Välj bilder"
          :uid="project.uid"
          multiple
          @completed="project.images = [$event, ...project.images]"
        >
          <h1>Lägg till bilder</h1>
          <p>Dra och släpp bilder i denna rutan, eller</p>
        </ImageUploader>

        <div class="columns is-multiline">
          <div
            v-for="image in project.images"
            :key="image.name"
            class="column is-3"
            @click="ShowModalImage(`${$helpers.url}image/${image.name}`)"
          >
            <ProjectImage
              v-if="!$store.state.auth.success"
              :hidden="true"
              :image="`${$helpers.url}image/${image.name}`"
              link
            ></ProjectImage>
            <ProjectImage
              v-else
              :image="`${$helpers.url}image/${image.name}`"
              :hidden="false"
              link
            >
              <div class="buttons">
                <ToggleButton
                  icon="fas fa-check"
                  cssInactive="is-inverted is-outlined"
                  cssActive
                  :active="image.cover"
                  :css="
                    image.isLoading
                      ? 'is-loading is-small'
                      : 'is-small is-success'
                  "
                  @click.stop.prevent="SaveProjectImageCover(image)"
                  >Omslag</ToggleButton
                >

                <button
                  class="button is-danger is-small is-rounded"
                  @click.stop.prevent="ShowDeleteImageModal(image)"
                >
                  Ta bort
                </button>
              </div>
            </ProjectImage>
          </div>
        </div>
      </div>
    </div>

    <BModalSimple
      v-if="modalImage && project"
      v-model="showModal"
      @hide="HideModal()"
    >
      <img
        loading="lazy"
        class="mini-rounded"
        :src="modalImage"
        @click="HideModal()"
      />
    </BModalSimple>

    <DeleteProject
      v-if="project"
      v-model="showDeleteModal"
      :project="project"
      @deleted="$helpers.GoTo('/projekt')"
    ></DeleteProject>

    <DeleteImage
      v-if="imageToDelete"
      v-model="showDeleteImageModal"
      :image="imageToDelete"
      @deleted="
        project.images = project.images.filter((x) => x.uid != $event.uid)
      "
    ></DeleteImage>
  </div>
</template>

<script>
import ImageH from "@/components/singles/ImageH.vue";
import Project from "@/components/singles/Project.vue";
import DeleteProject from "@/components/main/DeleteProject.vue";
import DeleteImage from "@/components/main/DeleteImage.vue";
import ProjectImage from "@/components/singles/ProjectImage.vue";
import BModalSimple from "@/components/singles/BModalSimple/component.vue";
import EditField from "@/components/main/EditField.vue";
import ToggleButton from "@/components/singles/ToggleButton.vue";
import EditSingleField from "@/components/singles/EditSingleField/component.vue";
import ImageUploader from "@/components/singles/ImageUploader.vue";

export default {
  components: {
    ImageH,
    Project,
    ProjectImage,
    BModalSimple,
    EditField,
    EditSingleField,
    ToggleButton,
    DeleteProject,
    DeleteImage,
    ImageUploader,
  },
  data() {
    return {
      imageToDelete: null,
      showDeleteImageModal: false,
      showModal: false,
      ready: false,
      imageModalReady: false,
      modalImage: null,
      project: null,
      showDeleteModal: false,
      loadProjects: false,
    };
  },
  computed: {
    hasPage: function() {
      if (this.project) {
        return this.project.pages.find((x) => x.name == "/") ? true : false;
      }
      return false;
    },

    cover() {
      if (this.project && this.project.images) {
        const image = this.project.images.find((x) => x.cover);
        if (image) {
          return `${this.$helpers.url}image/${image.name}`;
        }
      }

      return require("../assets/img/no-image.svg");
    },
  },
  created() {
    window.scrollTo(0, 0);
    this.GetProject();
    this.ready = true;
  },
  mounted() {
    // document.addEventListener("scroll", this.Seen);
  },
  beforeDestroy() {},

  methods: {
    async Seen() {
      if (await this.$helpers.CheckViewPort("a")) {
        this.loadProjects = true;
        document.removeEventListener("scroll", this.Seen);
      }
    },
    ShowDeleteImageModal(image) {
      if (image.cover && this.project.active) {
        this.$helpers.ShowStatus(
          "Projektet är publicerat och bilden är det aktuella omslaget. Välj ett annat omslag innan du tar bort bilden, eller gör projektet icke publikt.",
          0,
          "warning"
        );
      } else {
        this.imageToDelete = image;
        this.showDeleteImageModal = true;
      }
    },

    async SaveProjectImageCover(image) {
      image.isLoading = true;
      await this.$helpers.PostApi("set/cardImageCover", {
        cardUID: this.project.uid,
        imageUID: image.uid,
      });

      this.project.images = this.project.images.map((x) => {
        x.cover = false;
        return x;
      });
      image.cover = true;
      image.isLoading = false;
      this.$helpers.ShowStatus("Sparat.", 3000);
    },
    HideModal() {
      this.showModal = false;
      this.imageModalReady = false;
      this.modalImage = null;
    },
    ShowModalImage(src) {
      this.modalImage = src;
      this.showModal = true;
    },
    SaveProject(value) {
      return this.$helpers.PostApi("set/pageCard", {
        pageName: "/projects",
        path: this.$helpers.GetSeoStr(this.project.title.value),
        uid: this.project.uid,
        object: {
          active: this.project.active,
          title: this.project.title.value,
          subtitle: this.project.subtitle.value,
          description: value || this.project.description.value,
        },
      });
    },

    CheckImages() {
      if (!this.project.images || this.project.images.length === 0) {
        this.$helpers.ShowStatus(
          "Ladda upp minst en bild och välj ett omslag innan projektet publiceras.",
          10000
        );

        return false;
      } else if (!this.project.images.find((x) => x.cover)) {
        this.$helpers.ShowStatus(
          "Välj ett omslag innan projektet publiceras.",
          10000
        );

        return false;
      }

      return true;
    },

    async SaveProjectProp(prop, value) {
      if (this.CheckImages()) {
        await this.$helpers.PostApi("set/pageCard", {
          pageName: "/projects",
          uid: this.project.uid,
          object: { [prop]: value },
        });
        this.project[prop] = value;

        this.$helpers.ShowStatus("Sparat.", 3000);
      }
    },

    async AddRemoveProjectPage(pageName) {
      let path;
      this.hasPage ? (path = "delete") : (path = "set");

      await this.$helpers.PostApi(`${path}/cardPage`, {
        pageName: pageName,
        uid: this.project.uid,
      });

      this.hasPage
        ? (this.project.pages = this.project.pages.filter(
            (x) => x.name !== pageName
          ))
        : (this.project.pages = [{ name: pageName }, ...this.project.pages]);

      this.$helpers.ShowStatus("Sparat.", 3000);
    },
    async GetProject() {
      let result = await this.$helpers.PostApi(
        "get/pageCard",
        {
          pageName: "/projects",
          path: this.$route.params.id,
          active: this.$store.state.auth.role.level <= 2 ? null : true,
        },
        true
      );

      if (result.length != 0) {
        let project = result[0].card;
        let pages = result[0].pages;
        let images = result[0].images;

        this.project = {
          description: { value: project.description },
          title: { value: project.title },
          subtitle: { value: project.subtitle },
          active: !!project.active,
          uid: project.uid,
          pages: pages,
          images: images,
        };
      }
    },
  },
};
</script>
